<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="data.form.unidadesSolicitantes"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeSolicitanteId"
                            value-field="id"
                            @change="list('unidadeSolicitanteId')"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todos"
                            :options="infraestruturasSolicitante"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaSolicitanteId"
                            value-field="id"
                            @change="list('infraestruturaSolicitanteId')"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="data.form.unidadesExecutantes"
                            label="Unidade executante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                            @change="list('unidadeId')"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todos"
                            :options="infraestruturasExecutante"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                            @change="list('infraestruturaId')"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="data.form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.statusId"
                            value-field="id"
                            @change="list('statusId')"
                        />
                    </rkm-col>

                    <rkm-col cols="4">

                        <rkm-form-input-autocomplete
                            :repository="repositories.relatorio.procedimento"
                            :search-fields="fieldsProcedimento"
                            :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                            :request-query-string-params="requestQueryStringParamsUsuarioProcedimento"
                            label="Procedimento"
                            v-model="model.procedimento"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="data.form.exames"
                            default-option-text="Todos"
                            label="Exames"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            @change="list('exameId')"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="data.form.ocupacoes"
                            default-option-text="Todos"
                            label="CBO do profissional executante"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                            @change="list('ocupacaoId')"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="data.form.profissionais"
                            default-option-text="Todos"
                            label="Profissional Executante"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissionalId"
                            value-field="id"
                            @change="list('profissionalId')"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="data.form.prestadores"
                            default-option-text="Todos"
                            label="Prestador"
                            show-default-option
                            text-field="nome"
                            v-model="model.prestadorId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                            class="float-left"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                            class="mr-2 float-left"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="isSearch"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                ref="Table"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                hide-filters
            >
                <template v-slot:cell(nomeProcedimento)="row">
                    <template v-if="row.item.nomeProcedimento === null || row.item.nomeProcedimento === ''|| row.item.nomeProcedimento === 0">
                        SEM PROCEDIMENTO
                    </template>
                    <template v-else>
                        {{ row.item.nomeProcedimento }}
                    </template>
                </template>

                <template v-slot:custom-foot>
                    <rkm-tr>
                        <rkm-th :colspan="columns.length" class="table-td">
                            <rkm-row>
                                <rkm-col cols="6"></rkm-col>
                                <rkm-col cols="6" class="text-right">Total geral de exames: {{ totalExames() }}</rkm-col>
                            </rkm-row>
                        </rkm-th>
                    </rkm-tr>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import formatsFilter from '@/filters/formats'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, data, object, stringCase, file, formats } from '@/mixins'

export default {
    created() {

        this.repositories = {
            relatorio: this.getConectaSusRepository('exameImagem.relatorioProducao'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            exportacao: this.getConectaSusRepository('exportacao.exameImagem'),
        }

        this.load()
    },
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        requestQueryStringParamsUsuarioProcedimento() {
            const request = this.clone(this.model)

            request.periodo.start = this.others.moment(this.model.periodo.start).format('YYYY-MM-DD')
            request.periodo.end = this.others.moment(this.model.periodo.end).format('YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(request)
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        infraestruturasSolicitante(){

            let infraestruturasOrigem = []
            let infraestruturas = this.data.form.unidadesSolicitantes

            if (this.model.unidadeSolicitanteId) {
                infraestruturas = infraestruturas.filter(unidade => unidade.id === this.model.unidadeSolicitanteId)
            }

            infraestruturas.map(infraestrutura => {

                infraestrutura.infraestruturas.map(unidade => {

                    let existe = infraestruturasOrigem.find(u => u.id === unidade.id)

                    if(!existe){

                        infraestruturasOrigem.push({

                            id: unidade.id,
                            nome: unidade.nome,
                            principal: unidade.principal,
                        })
                    }
                })
            })

            this.setInfraestruturaSolicitante(infraestruturasOrigem)

            return infraestruturasOrigem
        },
        infraestruturasExecutante(){

            let infraestruturasOrigem = []
            let infraestruturas = this.data.form.unidadesExecutantes

            if (this.model.unidadeExecutanteId) {
                infraestruturas = infraestruturas.filter(unidade => unidade.id === this.model.unidadeExecutanteId)
            }

            infraestruturas.map(infraestrutura => {

                infraestrutura.infraestruturas.map(unidade => {

                    let existe = infraestruturasOrigem.find(u => u.id === unidade.id)

                    if(!existe){

                        infraestruturasOrigem.push({

                            id: unidade.id,
                            nome: unidade.nome,
                            principal: unidade.principal,
                        })
                    }
                })
            })

            this.setInfraestruturaExecutante(infraestruturasOrigem)

            return infraestruturasOrigem
        },
    },
    data: () => ({
        additionals: {},
        form: null,
        defaultModel: null,
        fieldsProcedimento: [
            {key: 'codigo', searchable: true},
            {key: 'nome', searchable: true},
        ],
        fieldMap: [
            'unidadeSolicitanteId',
            'infraestruturaSolicitanteId',
            'unidadeId',
            'infraestruturaId',
            'statusId',
            'procedimento',
            'exameId',
            'ocupacaoId',
            'profissionalId',
            'prestadorId',
        ],
        others: {moment},
        model: {
            periodo: {
                start: null,
                end: null,
            },
            exameId: null,
            procedimento: null,
            prestadorId: null,
            profissionalId: null,
            unidadeSolicitanteId: null,
            infraestruturaSolicitanteId: null,
            unidadeId: null,
            infraestruturaId: null,
            statusId: null,
            ocupacaoId: null,
        },
        selectedAll: false,
        indeterminate: false,
        selectedCols: [],
        itens: [],
        cols: [],
        totalizadores: null,
        verificaUnidade: false,
        isSearch: false,
        sortBy: 'nomeProcedimento',
        sortDesc: false,
        columns: [
            { key: 'procedimento', label: 'Código do procedimento', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'nomeProcedimento', label: 'Descrição do procedimento', sortable: true, fixed: true },
            { key: 'exameNome', label: 'Exame', sortable: true, fixed: false },
            { key: 'unidadeSolicitanteNome', label: 'Unidade solicitante', sortable: true, fixed: false },
            { key: 'infraestruturaSolicitanteNome', label: 'Local de atendimento solicitante', sortable: true, fixed: false },
            { key: 'nomeFantasia', label: 'Unidade executante', sortable: true, fixed: false },
            { key: 'infraestruturaNome', label: 'Local de atendimento executante', sortable: true, fixed: false },
            { key: 'nomePrestador', label: 'Prestador', sortable: true, fixed: false },
            { key: 'ocupacaoCodigo', label: 'CBO do profissional executante', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'ocupacaoNome', label: 'Descrição do CBO', sortable: true, fixed: true },
            { key: 'profissional', label: 'Profissional executante', sortable: true, fixed: true },
            { key: 'statusNome', label: 'Status', sortable: true, fixed: true },
            { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true, fixed: true },
        ],
    }),
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end

            this.addWatchers()
        },
        list(field) {

            this.setFields(field)

            this.setLoading()
            this.repositories.relatorio.list(this.prepareData())
                .then(({ data }) => {

                    this.$emit('handleList', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        search() {

            this.setLoading()
            this.repositories.relatorio.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data
                    this.totalizadores = data.totalizadores
                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {

            this.setLoading()
            this.repositories.impressao.relatorioProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()
            this.repositories.exportacao
                .exportProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers["content-type"]))
                .finally(() => this.unsetLoading());
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            data.totalExames = this.itens.map(item => item.quantidade)
                .reduce((accumulator,value) => accumulator + value,0)

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            return data
        },
        prepareData() {

            const data = this.clone(this.model)
            data.procedimentoCodigo = data.procedimento ? data.procedimento.codigo : null

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        resetDatatable(){

            this.model.statusId = null
            this.model.procedimento = null
            this.model.exameId = null
            this.isSearch = false
        },
        resetForm() {

            this.model.exame =  null
            this.model.dataNascimento = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.unidadeSolicitanteId = null
            this.model.infraestruturaSolicitanteId = null
            this.model.statusId = null
            this.model.procedimento = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.prestadorId = null
            this.isSearch = false

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        setDefaultValues() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
            this.resetDatatable()
        },
        totalExames(){

            return this.itens.map(item => item.quantidade)
                .reduce((accumulator,value) => accumulator + value,0)
        },
        addWatchers() {

            this.$watch('model.periodo.start', function () {

                if(this.model.periodo.start && this.model.periodo.end) {

                    this.list()
                }
            })

            this.$watch('model.periodo.end', function () {

                if(this.model.periodo.start && this.model.periodo.end) {

                    this.list()
                }
            })
        },
        setFields(value) {

            this.isSearch = false

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    this.$set(this.model, field, null);
                }
            }
        },
        setInfraestruturaSolicitante(infraestruturasOrigem) {

            if (this.model.unidadeSolicitanteId !== null) {

                const unidadePrincipal = infraestruturasOrigem.find(unidade => unidade.principal);

                if (unidadePrincipal) {

                    this.model.infraestruturaSolicitanteId = unidadePrincipal.id;
                } else if (infraestruturasOrigem.length === 1) {

                    this.model.infraestruturaSolicitanteId = infraestruturasOrigem[0].id;
                }
            }
        },
        setInfraestruturaExecutante(infraestruturasOrigem) {

            if (this.model.unidadeId !== null) {

                const unidadePrincipal = infraestruturasOrigem.find(unidade => unidade.principal);

                if (unidadePrincipal) {

                    this.model.infraestruturaId = unidadePrincipal.id;
                } else if (infraestruturasOrigem.length === 1) {

                    this.model.infraestruturaId = infraestruturasOrigem[0].id;
                }
            }
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, error, data, object, stringCase, file, formats],
    watch: {
        'model.procedimento': function(){

            this.list('procedimento')
        },
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
    .dropdown>>>.auto-scroll {
        max-height: 400px;
        overflow-y: auto;
        width: 400px;
    }
</style>